export const ACTIVE_USERS = 'Active Users';
export const AMOUNT = 'Amount';
export const DATE = 'Date';
export const DAYS = 'Days';
export const EXPENSE_CODE = 'Expense Code';
export const PRODUCT = 'Product';
export const PROGRAM = 'Program';
export const WEEK = 'Week';
export const TRAVEL = 'Travel';
export const ORDERS_VOLUME = 'Orders volume';
